import { CheckableList } from 'components/CheckableList/CheckableList'
import { Container, ContainerContent, ContainerHeader } from 'components/Containers/Containers'
import { Input } from 'components/Input/Input'
import { ToggleButton } from 'components/Input/ToggleButton'
import { NavBar } from 'components/NavBar/NavBar'
import {
    createPermitType,
} from 'features/operations/permitsSlice'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { AppDispatch, RootState } from 'store'
import { Button } from 'components/ui/Button/Button'
import { Flex, H1WithBack, PageFooter, PageWrapper } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import { ISelectValue } from 'constants/globalTypes'
import { IPermitTypeFormState } from 'types/permitTypes.interface'
import { DEFAULT_PERMIT_TYPE_FORM } from '../permitsData'

export const AddPermitType = () => {
    const navigate = useNavigate()
    const dispatch = useDispatch<AppDispatch>()
    const { isLoading, singlePermitType } = useSelector((state: RootState) => state.permits.permitTypes)
    const [state, setState] = useState<IPermitTypeFormState>({ ...DEFAULT_PERMIT_TYPE_FORM })

    useEffect(() => {
        if (singlePermitType) {
            setState(singlePermitType)
        }
    }, [singlePermitType])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value, name, type } = e.target
        setState((prev) => ({ ...prev, [name]: type === 'number' ? Number(value) : value }))
    }

    const handleCapabilitiesChange = (capabilities: ISelectValue[]) => {
        setState((prev) => ({ ...prev, requiredCapabilities: capabilities }))
    }

    const handleSave = async () => {
        const resp = await dispatch(createPermitType(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            navigate(-1)
        }
    }

    return (
        <>
            <NavBar />
            <PageWrapper>
                <H1WithBack
                    arrow
                    title='Add Permit Type'
                />
                <Flex mt='32' gap='1rem' column>
                    <Container>
                        <ContainerHeader>
                            <TitleText weight='bold'>Details</TitleText>
                        </ContainerHeader>
                        <ContainerContent>
                            <Flex gap='1rem' column>
                                <Flex gap='1rem'>
                                    <Input
                                        name='name'
                                        labelText='Name'
                                        value={state.name}
                                        onChange={handleChange}
                                        placeholder='Enter name...'
                                    />
                                    <Input
                                        name='code'
                                        labelText='Code'
                                        value={state.code}
                                        onChange={handleChange}
                                        placeholder='Enter code...'
                                    />

                                </Flex>
                                <Input
                                    name='minHolders'
                                    type='number'
                                    labelText='Minimum holders'
                                    value={state.minHolders}
                                    onChange={handleChange}
                                    placeholder='Enter minimum holders...'
                                />
                                <ToggleButton
                                    state={state.requiresCoPresence}
                                    handleChange={() =>
                                        setState((prev) => ({
                                            ...prev,
                                            requiresCoPresence: !prev.requiresCoPresence,
                                        }))
                                    }
                                    label='Requires co-presence'
                                    maxWidth
                                />
                            </Flex>
                        </ContainerContent>
                    </Container>
                    <Container>
                        <ContainerHeader>
                            <TitleText weight='bold'>Required capabilities</TitleText>
                        </ContainerHeader>
                        <ContainerContent>
                            <CheckableList
                                link='capability'
                                parserFunction={(data: any) =>
                                    data.data.map((c: any) => ({ value: c.id, label: c.name }))
                                }
                                selected={state.requiredCapabilities}
                                onChange={handleCapabilitiesChange}
                                selectedLabelText='Selected capabilities'
                                selectedPlaceholder='No capabilities selected'
                                listMaxHeight='16rem'
                                searchEnabled
                            />
                        </ContainerContent>
                    </Container>
                </Flex>
                <PageFooter>
                    <Flex gap='1rem' mt='32' justend>
                        <Button variant='secondary' onClick={() => navigate(-1)}>
                            Cancel
                        </Button>
                        <Button variant='primary' disabled={isLoading} onClick={handleSave}>
                            Save
                        </Button>
                    </Flex>
                </PageFooter>
            </PageWrapper>
        </>
    )
}
